import jquery from 'jquery'

export const $ = jquery

export default window.$ = window.jQuery = jquery
